import type {GuessModelV1, QuestionModelV3} from '@albert-io/models';
import {callTargetedAction} from 'client/framework';
import {invalidateUserPoints} from 'client/GlobalNavigation/PointsIndicator/PointsIndicator';
import sessionStore from 'client/Session/SessionStore';
import questionTypeActions from 'components/QuestionTypes/questionType.actions';

interface Options {
  question: QuestionModelV3;
  timeElapsed: number;
  assignmentId?: string;
  practiceId?: string;
}

/** Submits the response held in a legacy Flux question store and refreshes the question with it. */
export async function submitLegacyGuess({
  question,
  timeElapsed,
  assignmentId,
  practiceId
}: Options): Promise<GuessModelV1> {
  const guess = await question.getStore().buildGuess({timeElapsed, practiceId}).submitGuess({
    assignmentId,
    practiceId,
    userId: sessionStore.getUserId(),
    questionType: question.getQuestionType(),
    withStandards: false,
    withCalculatorTier: true
  });

  callTargetedAction({
    name: questionTypeActions.UPDATE_QUESTION,
    targetStore: question.getStore().getName(),
    payload: question
  });
  invalidateUserPoints();

  return guess;
}
